export default __webpack_public_path__ + "static/media/8.b570f811.mp3";